/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import styled from '@emotion/styled';

import { useParams } from 'js/lib/useRouter';

import type { Theme } from '@coursera/cds-core';
import { Typography } from '@coursera/cds-core';

import { isDegreeHomeV2Enabled } from 'bundles/degree-home/utils/experimentUtils';
import { Card } from 'bundles/program-loggedin-shared/components/Card';

export const CardV1 = styled.div`
  border: 1px solid ${({ theme }) => theme.palette.gray[300]};
  border-radius: 3px;
  padding: ${({ theme }) => theme.spacing(24)};
  margin-bottom: ${({ theme }) => theme.spacing(24)};
  background: ${({ theme }) => 'var(--cds-color-white-0)'};
`;

const styles = {
  title: (theme: Theme) => css`
    margin-bottom: ${theme.spacing(24)};
  `,
};

// Alongside our custom props, allow HTML Div attributes (e.g. data-* for e2e test tagging)
type CardProps = React.HTMLAttributes<HTMLDivElement> & {
  title?: string;
  children: React.ReactNode;
};

export const SummaryCard: React.VFC<CardProps> = ({ title, children, ...attributes }) => {
  const { degreeSlug } = useParams();

  const CardComponent = isDegreeHomeV2Enabled(degreeSlug) ? Card : CardV1;

  return (
    <CardComponent {...attributes}>
      {title && (
        <Typography css={styles.title} variant="h2semibold">
          {title}
        </Typography>
      )}
      {children}
    </CardComponent>
  );
};

export default SummaryCard;
